import { flattenDeep } from 'lodash';

export const collectFlatten = (...items: any[]): any[] => {
  return [...flattenDeep(items.filter(i => i !== undefined))];
};